{
  "_comment": "Справочник видов программы для дропдауна в секции «Спортсмены». Дропдаун наполняется из этого файла. Правки — только организаторам, не агентам.",
  "version": 1,
  "disciplines": [
    {
      "id": "chantsyuan",
      "name": "Чанцюань"
    },
    {
      "id": "chantsyuan-bazovyy",
      "name": "Чанцюань базовый"
    },
    {
      "id": "nantsyuan",
      "name": "Наньцюань"
    },
    {
      "id": "nantsyuan-bazovyy",
      "name": "Наньцюань базовый"
    },
    {
      "id": "tszyanshu",
      "name": "Цзяньшу"
    },
    {
      "id": "tszyanshu-bazovyy",
      "name": "Цзяньшу базовый"
    },
    {
      "id": "daoshu",
      "name": "Даошу"
    },
    {
      "id": "daoshu-bazovyy",
      "name": "Даошу базовый"
    },
    {
      "id": "nandao",
      "name": "Наньдао"
    },
    {
      "id": "nandao-bazovyy",
      "name": "Наньдао базовый"
    },
    {
      "id": "tsyanshu",
      "name": "Цяншу"
    },
    {
      "id": "tsyanshu-bazovyy",
      "name": "Цяншу базовый"
    },
    {
      "id": "gunshu",
      "name": "Гуньшу"
    },
    {
      "id": "gunshu-bazovyy",
      "name": "Гуньшу базовый"
    },
    {
      "id": "nangun",
      "name": "Наньгунь"
    },
    {
      "id": "nangun-bazovyy",
      "name": "Наньгунь базовый"
    },
    {
      "id": "taytszitsyuan",
      "name": "Тайцзицюань"
    },
    {
      "id": "taytszi-oruzhie",
      "name": "Тайцзи оружие"
    },
    {
      "id": "traditsionnoe-tsyuan-shu-1-gr",
      "name": "Традиционное цюань шу 1 гр"
    },
    {
      "id": "traditsionnoe-tsyuan-shu-2-gr",
      "name": "Традиционное цюань шу 2 гр"
    },
    {
      "id": "traditsionnoe-tsyuan-shu-3-gr",
      "name": "Традиционное цюань шу 3 гр"
    },
    {
      "id": "traditsionnoe-tsyuan-shu-4-gr",
      "name": "Традиционное цюань шу 4 гр"
    },
    {
      "id": "traditsionnoe-tsyuan-shu-5-gr",
      "name": "Традиционное цюань шу 5 гр"
    },
    {
      "id": "traditsionnoe-oruzhie-odinochnoe",
      "name": "Традиционное оружие одиночное"
    },
    {
      "id": "traditsionnoe-oruzhie-parnoe",
      "name": "Традиционное оружие парное"
    },
    {
      "id": "traditsionnoe-oruzhie-gibkoe",
      "name": "Традиционное оружие гибкое"
    },
    {
      "id": "duylyan-bez-oruzhiya",
      "name": "Дуйлянь без оружия"
    },
    {
      "id": "duylyan-c-oruzhiem",
      "name": "Дуйлянь c оружием"
    },
    {
      "id": "duylyan-prochie",
      "name": "Дуйлянь прочие"
    },
    {
      "id": "tszitisyanmu",
      "name": "Цзитисянму"
    }
  ]
}
